import moment from "moment";

export const formatDate = (date) => {
    if (!date) return "";
    return moment(date).format("DD-MM-YYYY");
};

export const formatDateTime = (date) => {
    if (!date) return "";
    return moment(date).format("DD-MM-YYYY - hh:mm A");
};

export const stripHtml = (html) => {
    if (!html) return "";
    return String(html).replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
};

export const showFullDate = (date) => {
    if (!date || date === "-") return "";
    return moment.utc(moment(date)).local().format("Do MMM YYYY , h:mm A");
};

export const showTimeZoneDate = (date) => {
    if (!date || date === "-") return "";
    return moment.utc(moment(date)).local().format("DD-MM-YYYY h:mm a");
};

export const showZoneDate = (date) => {
    if (!date || date === "-") return "";
    return moment.utc(moment(date)).local().format("DD-MM-YYYY");
};

export const showZoneTime = (time) => {
    if (!time || time === "-") return "";
    return moment.utc(moment(time)).local().format("h:mm a");
};

export const getFromToDate = (date) => {
    if (!date || date === "-") return "";
    return moment.utc(moment(date)).local().format("YYYY-MM-DD");
};

export const parseDateString = (dateString) => {
    if (!dateString) return false;
    const [day, month, year] = String(dateString).split("-").map(Number);
    return new Date(Date.UTC(year, month - 1, day));
};

export const hourBetweenDate = (date1, date2) => {
    const hours = (new Date(date2).valueOf() - new Date(date1).valueOf()) / 1000 / 60 / 60;
    return hours > 0 ? { status: true, hours: Math.ceil(hours) } : { status: false };
};

export const startOfDay = (date) => new Date(new Date(date).setHours(0, 0, 0, 0));
export const endOfDay = (date) => new Date(new Date(date).setHours(23, 59, 59, 999));

export const textCapital = (value) => {
    return String(value)
        ?.split(" ")
        ?.map((word) => (word ? `${word[0]?.toUpperCase()}${word.slice(1)?.toLowerCase()}` : ""))
        ?.join(" ");
};

export const textCapitalize = (data) => {
    if (!data) return data;
    return data.charAt(0).toUpperCase() + data.slice(1);
};

export const shrinkText = (text, count = 30) => {
    return text?.length > Number(count) ? `${text.slice(0, Number(count))}...` : text;
};

export const isTrimmed = (str) => String(str) !== String(str).trim();

export const currencyFormatter = (amount, code = "INR") => {
    return new Intl.NumberFormat("en-IN", { style: "currency", currency: code }).format(amount || 0);
};

export const randomId = () => {
    if (window.crypto?.randomUUID) return window.crypto.randomUUID();
    return `id-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
};

export const setCookie = (name, storevalue) => {
    document.cookie = `${name}=${storevalue}; path=/`;
};

export const setCookieWithExpiry = (name, storevalue, expirydays) => {
    const d = new Date();
    d.setTime(d.getTime() + expirydays * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${storevalue};expires=${d.toUTCString()};path=/`;
};

export const getCookie = (name) => {
    const getName = `${name}=`;
    const ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === " ") c = c.substring(1);
        if (c.indexOf(getName) === 0) return c.substring(getName.length, c.length);
    }
    return "";
};

export const removeCookie = (name) => {
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
};

export const deleteAllCookies = () => {
    document.cookie.split(";").forEach((cookie) => {
        const eqPos = cookie.indexOf("=");
        const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
    });
};

export const storageSetItem = (key, value) => window.localStorage.setItem(key, JSON.stringify(value));
export const storageGetItem = (key) => {
    try {
        return JSON.parse(window.localStorage.getItem(key));
    } catch (error) {
        return null;
    }
};
export const storageRemoveItem = (key) => window.localStorage.removeItem(key);
export const storageRemoveAll = () => window.localStorage.clear();

export const sessionStorageSetItem = (key, value) => window.sessionStorage.setItem(key, JSON.stringify(value));
export const sessionStorageGetItem = (key) => {
    try {
        return JSON.parse(window.sessionStorage.getItem(key));
    } catch (error) {
        return null;
    }
};
export const sessionStorageRemoveItem = (key) => window.sessionStorage.removeItem(key);
export const sessionStorageRemoveAll = () => window.sessionStorage.clear();

export const returnFirstDegreeObjValue = (obj, key) => {
    return obj && (obj[key] || obj[key] === 0) ? obj[key] : "N/A";
};

export const returnSecondDegreeObjValue = (obj, key, position) => {
    if (obj && obj[key] && (obj[key][position] || obj[key][position] === 0)) return obj[key][position];
    return "N/A";
};

export const toObjectFormat = (input) => {
    if (Array.isArray(input)) return input[0] || {};
    if (typeof input === "object" && input !== null) return { ...input };
    return {};
};

export const removeEmptyKeys = (obj) => {
    const clone = { ...obj };
    Object.keys(clone).forEach((key) => {
        const value = clone[key];
        if (value === undefined || value === null || (typeof value === "string" && !value.trim())) {
            delete clone[key];
        }
    });
    return clone;
};

export const parseJson = (jsondata) => {
    try {
        return JSON.parse(jsondata);
    } catch (error) {
        return null;
    }
};

export const stringifyJson = (jsondata) => JSON.stringify(jsondata);

export const reloadWindow = () => window.location.reload();
export const reloadWindowToPath = (pathtoload) => {
    window.location.href = pathtoload;
};

export const copyContent = async (content) => {
    await navigator?.clipboard?.writeText(content);
};
